export interface IPaginationResultAssets<T> {
  totalPages: number;
  totalAssets: number;
  assetsPerPage: number;
  currentPage: number;
  isLastPage: boolean;
  assets: T[];
}

export type MfrErrors =
  | 'Manufacturer Not Found'
  | 'Manufacturer field is Empty';
export type MpnErrors =
  | 'Model Number Not Found'
  | 'Model Number field is Empty'
  | 'Manufacturer Part Number is Invalid';
export type ProductNameErrors =
  | 'Product Name Not Found'
  | 'Product Name field is Empty';

export type AssetStatusOptions =
  | 'inventory'
  | 'nonMatched'
  | 'matched'
  | 'discarded'
  | 'error';

export interface IOnboardingAsset {
  id: string;
  status: AssetStatusOptions;
  model: string;
  manufacturer: string;
  productName: string;
  otherFields: {
    [x: string]: string;
  };
  equipmentFields: {
    [x: string]: string;
  };
  mpnError: MpnErrors | null;
  mpnSuggestions: {
    product_model: string;
  }[];
  mfrError: MfrErrors | null;
  mfrSuggestions: [];
  productNameError: ProductNameErrors | null;
  productNameSuggestions: {
    product_name: string;
  }[];
  isNotAccessory: boolean;
  accessoryError: string | null;
  isManufacturerAccessory: boolean;
  accessoryKeyword: string[];
  createdAt: Date;
  updatedAt: Date;
  productId: string | null;
}

export interface IOnboardingAssetApi {
  _id: string;
  status: AssetStatusOptions;
  mpn: string;
  mfr: string;
  productName: string;
  otherFields: {
    [x: string]: string;
  };
  equipmentFields: {
    [x: string]: string;
  };
  mpnError: MpnErrors | null;
  mpnSuggestions: {
    product_model: string;
  }[];
  mfrError: MfrErrors | null;
  mfrSuggestions: [];
  productNameError: ProductNameErrors | null;
  productNameSuggestions: {
    product_name: string;
  }[];
  isNotAccessory: boolean;
  accessoryError: string | null;
  isManufacturerAccessory: boolean;
  accessoryKeyword: string[];
  createdAt: string;
  updatedAt: string;
  productId: string | null;
}

export default class Tag implements IOnboardingAsset {
  public readonly id: string;

  public readonly status: AssetStatusOptions;

  public readonly model: string;

  public readonly manufacturer: string;

  public readonly productName: string;

  public readonly otherFields: {
    [x: string]: string;
  };

  public readonly equipmentFields: {
    [x: string]: string;
  };

  public readonly mpnError: MpnErrors | null;

  public readonly mpnSuggestions: {
    product_model: string;
  }[];

  public readonly mfrError: MfrErrors | null;

  public readonly mfrSuggestions: [];

  public readonly productNameError: ProductNameErrors | null;

  public readonly productNameSuggestions: {
    product_name: string;
  }[];

  public readonly isNotAccessory: boolean;

  public readonly accessoryError: string | null;

  public readonly isManufacturerAccessory: boolean;

  public readonly accessoryKeyword: string[];

  public readonly createdAt: Date;

  public readonly updatedAt: Date;

  public readonly productId: string | null;

  constructor(
    id: string,
    status: AssetStatusOptions,
    model: string,
    manufacturer: string,
    productName: string,
    otherFields: {
      [x: string]: string;
    },
    equipmentFields: {
      [x: string]: string;
    },
    mpnError: MpnErrors | null,
    mpnSuggestions: {
      product_model: string;
    }[],
    mfrError: MfrErrors | null,
    mfrSuggestions: [],
    productNameError: ProductNameErrors | null,
    productNameSuggestions: {
      product_name: string;
    }[],
    isNotAccessory: boolean,
    accessoryError: string | null,
    isManufacturerAccessory: boolean,
    accessoryKeyword: string[],
    createdAt: Date,
    updatedAt: Date,
    productId: string | null,
  ) {
    this.id = id;
    this.status = status;
    this.model = model;
    this.manufacturer = manufacturer;
    this.productName = productName;
    this.otherFields = otherFields;
    this.equipmentFields = equipmentFields;
    this.mpnError = mpnError;
    this.mpnSuggestions = mpnSuggestions;
    this.mfrError = mfrError;
    this.mfrSuggestions = mfrSuggestions;
    this.productNameError = productNameError;
    this.productNameSuggestions = productNameSuggestions;
    this.isNotAccessory = isNotAccessory;
    this.accessoryError = accessoryError;
    this.isManufacturerAccessory = isManufacturerAccessory;
    this.accessoryKeyword = accessoryKeyword;
    this.createdAt = createdAt;
    this.updatedAt = updatedAt;
    this.productId = productId;
  }

  static fromApiModel(apiModel: IOnboardingAssetApi) {
    const {
      _id,
      status,
      otherFields,
      equipmentFields,
      mfr,
      mfrError,
      mfrSuggestions,
      mpn,
      mpnError,
      mpnSuggestions,
      productName,
      productNameError,
      productNameSuggestions,
      accessoryError,
      isNotAccessory,
      isManufacturerAccessory,
      accessoryKeyword,
      productId,
    } = apiModel;

    const createdAt = new Date(Date.parse(apiModel.createdAt));
    const updatedAt = new Date(Date.parse(apiModel.updatedAt));

    return new Tag(
      _id,
      status,
      mpn,
      mfr,
      productName,
      otherFields,
      equipmentFields,
      mpnError,
      mpnSuggestions,
      mfrError,
      mfrSuggestions,
      productNameError,
      productNameSuggestions,
      isNotAccessory,
      accessoryError,
      isManufacturerAccessory,
      accessoryKeyword,
      createdAt,
      updatedAt,
      productId,
    );
  }

  static arrayFromApiModel(arrayApiModel: IOnboardingAssetApi[]) {
    const array = arrayApiModel.map(apiModel => this.fromApiModel(apiModel));

    return array;
  }

  static arrayPaginatedFromApiModel(
    arrayApiModel: IPaginationResultAssets<IOnboardingAssetApi>,
  ) {
    const array = this.arrayFromApiModel(arrayApiModel.assets);

    return {
      ...arrayApiModel,
      assets: array,
    };
  }
}
